export default {"src":"/_next/static/media/MongoDB.c9ba40a7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};